var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgInsights = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 21,
  height: 28,
  viewBox: "0 0 21 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M5.01053 22H15.0105V24H5.01053V22ZM7.01053 26H13.0105V28H7.01053V26ZM10.0105 0C7.36053 0 4.81058 1.0536 2.94058 2.9289C1.06058 4.8043 0.0105285 7.3478 0.0105285 10C-0.0594715 11.4533 0.220587 12.902 0.820587 14.2267C1.42059 15.5514 2.33049 16.7144 3.47049 17.62C4.47049 18.55 5.01053 19.08 5.01053 20H7.01053C7.01053 18.16 5.90059 17.13 4.82059 16.14C3.88059 15.4243 3.14054 14.4903 2.65054 13.4198C2.16054 12.3494 1.94053 11.1752 2.01053 10C2.01053 7.8783 2.85049 5.8434 4.35049 4.3431C5.85049 2.8429 7.89053 2 10.0105 2C12.1305 2 14.1606 2.8429 15.6706 4.3431C17.1706 5.8434 18.0105 7.8783 18.0105 10C18.0805 11.176 17.8505 12.3508 17.3605 13.4213C16.8705 14.4918 16.1206 15.4253 15.1906 16.14C14.1206 17.14 13.0105 18.14 13.0105 20H15.0105C15.0105 19.08 15.5406 18.55 16.5506 17.61C17.6906 16.706 18.5906 15.5447 19.1906 14.2217C19.8006 12.8987 20.0805 11.4518 20.0105 10C20.0105 8.6868 19.7505 7.3864 19.2505 6.1732C18.7405 4.9599 18.0105 3.8575 17.0805 2.9289C16.1505 2.0003 15.0505 1.2638 13.8405 0.7612C12.6205 0.2587 11.3205 0 10.0105 0Z",
  fill: "currentColor"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgInsights);
export { ForwardRef as ReactComponent };